import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Scheduling|Eligible Exams|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamFacebookExamScheduling,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSchedulingEligibleExams';
export type SPCandidateSchedulingEligibleExamsLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitleTable`
	| `${LocNameStart}LabelGroup`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelCode`;

export const spCandidateSchedulingEligibleExamsLocs: LocDefs<SPCandidateSchedulingEligibleExamsLocNames> =
	{
		SPCandidateSchedulingEligibleExamsTitleTab: {
			defaultValue: 'Eligible Exams',
			description: 'Tab Title',
			displayPath: `${pathStart}Tab Title`,
			displayType: 'Title',
			...sharedProperties,
		},
		SPCandidateSchedulingEligibleExamsTitleTable: {
			defaultValue: 'Eligible Exams',
			description: 'Table Title for accessibility purposes.',
			displayPath: `${pathStart}Table Title`,
			displayType: 'Title',
			...sharedProperties,
		},
		SPCandidateSchedulingEligibleExamsLabelGroup: {
			defaultValue: 'Group',
			description: 'Column heading for: Group.',
			displayPath: `${pathStart}Group`,
			displayType: 'Label',
			...sharedProperties,
		},
		SPCandidateSchedulingEligibleExamsLabelName: {
			defaultValue: 'Name',
			description: 'Column heading for: Name.',
			displayPath: `${pathStart}Name`,
			displayType: 'Label',
			...sharedProperties,
		},
		SPCandidateSchedulingEligibleExamsLabelCode: {
			defaultValue: 'Code',
			description: 'Column heading for: Code.',
			displayPath: `${pathStart}Code`,
			displayType: 'Label',
			...sharedProperties,
		},
	};

export type SPCandidateSchedulingEligibleExamsLocType =
	LocMap<SPCandidateSchedulingEligibleExamsLocNames>;
